package org.moxultimate.topwithmox.theme

import org.jetbrains.compose.web.css.px

val FontFamily = listOf("Kannada MN", "sans-serif")



/**
 * Title Sizes
 */
val MinTitleFontSize = 22.px
val MaxTitleFontSize = 30.px
val MobileMinTitleFontSize = 20.px
val MobileMaxTitleFontSize = 26.px


/**
 * Description Sizes
 */
val MinDescriptionFontSize = 16.px
val MaxDescriptionFontSize = 22.px
val MobileMinDescriptionFontSize = 14.px
val MobileMaxDescriptionFontSize = 20.px

/**
 * Chip Text Sizes
 */
val MinChipFontSize = 14.px
val MaxChipFontSize = 18.px



/**
 * Details Sizes
 */
val MinDetailFontSize = 18.px
val MaxDetailFontSize = 20.px

val MinDetailTypeFontSize = 13.px
val MaxDetailTypeFontSize = 15.px